import http from '../../../shared/utils/http'
import httpData from '../../../shared/utils/httpData'
import {VoiceInfoBK} from "../models/Header.model";

const url = 'header'

export const getMenuInfo: () => Promise<VoiceInfoBK> = () => http.get(`${httpData.other.organizationId}/init/GetMenuInfo`)

export const getLastDeviceSettings = (patientId: string) => http.get(`${httpData.other.urlDevice}DeviceManager/GetLastDevicesSettings/${patientId}`)